// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const ImageBlock = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 100 60" {...props}>
    <path
      stroke="currentColor"
      fill="none"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M19.3 10.9h61.4v38.2H19.3z"
    />
    <path
      stroke="currentColor"
      fill="none"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M19.3 34.6l12.8-12L58 49.1M70.6 26.2h0a5.76 5.76 0 01-5.7-5.7h0a5.76 5.76 0 015.7-5.7h0a5.76 5.76 0 015.7 5.7h0a5.7 5.7 0 01-5.7 5.7zM50.3 40.5l12.8-12 17.6 17.9"
    />
  </svg>
);

export default ImageBlock;
